"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.choosePoster = exports.canChoosePoster = void 0;
var player_base_1 = require("@24i/player-base");
var canChoosePoster = function (poster, usage) {
    return (!poster.usage ||
        poster.usage === player_base_1.SourcePosterUsage.GENERAL ||
        poster.usage === usage);
};
exports.canChoosePoster = canChoosePoster;
var choosePoster = function (posters, usage) {
    if (usage === void 0) { usage = player_base_1.SourcePosterUsage.GENERAL; }
    if (!posters)
        return undefined;
    var filtered = posters.filter(function (poster) { return exports.canChoosePoster(poster, usage); });
    var landscapePoster = filtered.find(function (poster) {
        return poster.width && poster.height && poster.width > poster.height;
    });
    return landscapePoster || posters[0];
};
exports.choosePoster = choosePoster;
//# sourceMappingURL=index.js.map